import styled from "styled-components";

export const HomeChildBox = styled.div`
    text-align: center;
    padding-bottom: 20px;
    border-bottom: 1px solid #c7c8c9;
    margin: 20px 0;
`